import { Award, Trophy, Star, Medal } from "lucide-react";
import { LevelItem } from "./LevelItem";

interface LevelsListProps {
  badgeCount: number | null;
  userLevel?: string;
  openLevels: number[];
  toggleLevel: (id: number) => void;
}

export const LevelsList = ({ 
  badgeCount, 
  userLevel, 
  openLevels, 
  toggleLevel 
}: LevelsListProps) => {
  const levels = [
    {
      id: 1,
      name: "Principiante",
      points: 0,
      icon: <Trophy className="w-8 h-8 text-foreground" />,
      completed: badgeCount >= 0,
      current: userLevel === 'principiante',
      benefits: ["Acceso a rutinas básicas", "1 clase gratis"],
      requirement: "Comienza tu viaje fitness. No requiere logros previos."
    },
    {
      id: 2,
      name: "Intermedio",
      points: 10,
      icon: <Medal className="w-8 h-8 text-foreground" />,
      completed: badgeCount >= 10,
      current: userLevel === 'intermedio',
      benefits: ["2 puntos por cada clase", "5% descuento en membresía"],
      requirement: "Obtén 10 logros completando rutinas y asistiendo a clases."
    },
    {
      id: 3,
      name: "Avanzado",
      points: 20,
      icon: <Star className="w-8 h-8 text-foreground" />,
      completed: badgeCount >= 20,
      current: userLevel === 'avanzado',
      benefits: ["3 puntos por cada clase", "10% descuento en membresía"],
      requirement: "Alcanza 20 logros demostrando tu compromiso con el entrenamiento."
    },
    {
      id: 4,
      name: "Elite",
      points: 50,
      icon: <Award className="w-8 h-8 text-foreground" />,
      completed: badgeCount >= 50,
      current: userLevel === 'elite',
      benefits: ["4 puntos por cada clase", "15% descuento en membresía", "Acceso prioritario a clases"],
      requirement: "Conviértete en Elite obteniendo 50 logros. ¡El máximo nivel!"
    }
  ];

  return (
    <div className="space-y-6">
      {levels.map((level) => (
        <LevelItem
          key={level.id}
          level={level}
          isOpen={openLevels.includes(level.id)}
          onToggle={() => toggleLevel(level.id)}
        />
      ))}
    </div>
  );
};